import HTLogo from './HTLogo';

export default HTLogo;
